import { buildApiUrl, tenantApiPrefix } from '../config';
import type { FeatureRead } from './featuresService';
import type { TenantBranding } from '../types/branding';
import type { TenantCurrency } from '../types/currency';
import type { NavSection } from '../navigation/types';

export interface BootstrapResponse {
  branding: TenantBranding;
  features: FeatureRead[];
  currency: TenantCurrency;
  /** The sidebar, built for this workspace by the server. */
  navigation?: NavSection[];
  /** This workspace's board of each spec: spec key -> dashboard id. */
  boards?: Record<string, string>;
}

const authHeaders = (): Record<string, string> => {
  const token = window.localStorage.getItem('klaris_jwt');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function fetchBootstrap(tenantId: string): Promise<BootstrapResponse> {
  const resp = await fetch(buildApiUrl(`${tenantApiPrefix(tenantId)}/bootstrap`), {
    headers: authHeaders(),
    cache: 'no-store',
  } as RequestInit);
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const detail = (data && (data.detail || data.message)) || `Request failed (${resp.status})`;
    throw new Error(typeof detail === 'string' ? detail : JSON.stringify(detail));
  }
  return data as BootstrapResponse;
}
